var map = {
	"./app-icon.svg": 1713,
	"./caret-right-icon.svg": 1714,
	"./chrome-icon.webp": 1715,
	"./edge-icon.webp": 1716,
	"./firefox-icon.webp": 1717,
	"./opera-icon.webp": 1718,
	"./safari-icon.webp": 1719,
	"./unknown-icon.webp": 1720
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1712;